(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return collectionLoadMore$1; }), Promise.resolve().then(function () { return collectionFilters$1; }), Promise.resolve().then(function () { return collectionToggles$1; }), Promise.resolve().then(function () { return collectionMenu$1; })];
        const componentsObj = hydrateComponents(components);
        await componentsObj.hydrate?.();
      })();
    });

    class CollectionLoadMore extends HTMLElement {
      btn = null;
      section = null;
      grid = null;
      bisModal = null;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        this.btn = this.querySelector('button');
        this.section = this.closest(`[data-ref="collection-section"]`);
        this.bisModal = document.body.querySelector('component-modal[data-ref="bis-modal"]');
        if (this.section) this.grid = this.section.querySelector('[data-ref="grid"]');
      };
      setupEventListeners = () => {
        if (this.btn) this.btn.addEventListener('click', this.handleClick);
      };
      removeEventListeners = () => {
        if (this.btn) this.btn.removeEventListener('click', this.handleClick);
      };
      handleClick = () => {
        this.render();
      };
      render = () => {
        const {
          nextUrl
        } = this.dataset;
        if (!nextUrl) return;
        fetch(`${nextUrl}&view=ajax`).then(response => response.text()).then(responseText => {
          const htmlDocument = new DOMParser().parseFromString(responseText, 'text/html');
          this.renderNewProducts(htmlDocument);
          this.renderLoadMore(htmlDocument);
        }).catch(error => {
          alert('Failed to load more products. Please try again.');
        });
      };
      renderNewProducts = htmlDocument => {
        if (!this.grid) return;
        const newProducts = Array.from(htmlDocument.querySelectorAll('component-product-card'));
        const oldProducts = document.querySelectorAll('component-product-card');
        const fragment = document.createDocumentFragment();
        newProducts.forEach(product => fragment.appendChild(product));
        oldProducts.forEach(s => {
          s.removeAttribute('style');
        });
        this.grid.removeAttribute('style');
        this.grid.appendChild(fragment);
        this.bisModal?.reInit();
      };
      renderLoadMore = htmlDocument => {
        const newLoadMore = htmlDocument.querySelector('collection-load-more');
        if (!newLoadMore) return;
        const isHidden = this.classList.contains('hidden');
        this.dataset.currentPage = newLoadMore.dataset.currentPage;
        this.dataset.totalPages = newLoadMore.dataset.totalPages;
        this.dataset.nextUrl = newLoadMore.dataset.nextUrl;
        if (this.dataset.currentPage === this.dataset.totalPages && !isHidden) this.classList.add('hidden');else if (isHidden) this.classList.remove('hidden');
      };
      static define = () => {
        if (!customElements.get('collection-load-more')) {
          customElements.define('collection-load-more', CollectionLoadMore);
        }
      };
    }
    var collectionLoadMore = () => {
      CollectionLoadMore.define();
    };

    var collectionLoadMore$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        CollectionLoadMore: CollectionLoadMore,
        default: collectionLoadMore
    });

    const {
      dispatchEvent
    } = window.PoleneLibs.Utils;
    const SELECTORS = {
      DRAWER: 'component-drawer',
      OPEN_BTN: '[data-ref="filters-open-btn"]',
      CLEAR_BTN: '[data-ref="filters-clear-btn"]',
      APPLY_BTN: '[data-ref="filters-apply-btn"]',
      COUNTER: '[data-ref="filters-counter"]',
      GRID: '[data-ref="grid"]',
      LOAD_MORE: 'collection-load-more',
      INPUT: 'input'
    };
    class CollectionFilters extends HTMLElement {
      openButton = null;
      clearButton = null;
      applyButton = null;
      drawer = null;
      section = null;
      renderedSections = {};
      inputs = [];
      counters = [];
      grid = null;
      loadMore = null;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        this.drawer = this.querySelector(SELECTORS.DRAWER);
        this.openButton = this.querySelector(SELECTORS.OPEN_BTN);
        this.clearButton = this.querySelector(SELECTORS.CLEAR_BTN);
        this.applyButton = this.querySelector(SELECTORS.APPLY_BTN);
        this.counters = Array.from(this.querySelectorAll(SELECTORS.COUNTER));
        this.section = this.closest(`[data-id="${this.dataset.sectionId}"]`);
        this.inputs = Array.from(this.querySelectorAll(SELECTORS.INPUT));
        if (this.section) {
          this.loadMore = this.section.querySelector(SELECTORS.LOAD_MORE);
          this.grid = this.section.querySelector(SELECTORS.GRID);
        }
      };
      setupEventListeners = () => {
        this.openButton?.addEventListener('click', this.handleOpen);
        this.clearButton?.addEventListener('click', this.handleClear);
        this.applyButton?.addEventListener('click', this.handleClose);
        this.inputs.forEach(input => input.addEventListener('click', this.handleInputClick));
        window.addEventListener('popstate', this.handlePopstate);
      };
      removeEventListeners = () => {
        this.openButton?.removeEventListener('click', this.handleOpen);
        this.clearButton?.removeEventListener('click', this.handleClear);
        this.applyButton?.removeEventListener('click', this.handleClose);
        this.inputs.forEach(input => input.removeEventListener('click', this.handleInputClick));
        window.removeEventListener('popstate', this.handlePopstate);
      };
      handleOpen = () => {
        window?.zE?.('messenger', 'hide');
        this.drawer?.open();
      };
      handleClose = () => {
        window?.zE?.('messenger', 'show');
        this.drawer?.close();
      };
      handleClear = () => {
        this.inputs.forEach(input => {
          input.checked = false;
          input.disabled = false;
        });
        this.render();
      };
      handlePopstate = event => this.render(event.state.searchParams);
      handleInputClick = event => {
        const target = event.target;
        const form = target.closest('form');
        if (!form) return;
        const searchParams = this.createSearchParams(form);
        this.render(searchParams);
      };
      render = (searchParams = '') => {
        const sectionId = this.dataset.sectionId;
        const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
        this.renderSection(url);
        this.updateURLHash(searchParams);
      };
      renderSection = url => {
        if (url in this.renderedSections) this.renderElements(this.renderedSections[url], url);else {
          fetch(url).then(response => response.text()).then(responseText => {
            const newSection = new DOMParser().parseFromString(responseText, 'text/html');
            this.renderedSections[url] = newSection;
            this.renderElements(newSection, url);
          }).catch(error => {});
        }
      };
      renderElements = (newSection, url) => {
        this.renderGrid(newSection);
        this.renderCounters(newSection);
        this.renderLoadMore(newSection);
        this.renderInputs(newSection);
        dispatchEvent(window, 'COLLECTION_FILTERS_RENDERED', {
          url: url || window.location.href,
          sectionId: this.dataset.sectionId
        });
      };
      renderInputs = newSection => {
        const newInputs = Array.from(newSection.querySelectorAll(SELECTORS.INPUT));
        this.inputs.forEach((input, index) => {
          if (input.id === newInputs[index].id) input.disabled = newInputs[index].disabled;else {
            const matchingNewInput = newInputs.find(newLabel => newLabel.id === input.id);
            if (matchingNewInput) input.disabled = matchingNewInput.disabled;
          }
        });
      };
      renderCounters = newSection => {
        const newCounters = Array.from(newSection.querySelectorAll(SELECTORS.COUNTER));
        const newApplyBtn = newSection.querySelector(SELECTORS.APPLY_BTN);
        if (!newApplyBtn || !this.applyButton) return;
        this.applyButton.innerHTML = newApplyBtn.innerHTML;
        this.counters.forEach((counter, index) => counter.innerHTML = newCounters[index].innerHTML);
      };
      renderLoadMore = newSection => {
        const newLoadMore = newSection.querySelector(SELECTORS.LOAD_MORE);
        if (!this.loadMore || !newLoadMore) return;
        this.loadMore.className = newLoadMore.className;
        this.loadMore.dataset.currentPage = newLoadMore.dataset.currentPage;
        this.loadMore.dataset.totalPages = newLoadMore.dataset.totalPages;
        this.loadMore.dataset.nextUrl = newLoadMore.dataset.nextUrl;
      };
      renderGrid = newSection => {
        const newGrid = newSection.querySelector(SELECTORS.GRID);
        if (!newGrid || !this.grid) return;
        this.grid.innerHTML = newGrid.innerHTML;
      };
      updateURLHash = searchParams => {
        history.pushState({
          searchParams
        }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
      };
      createSearchParams = form => {
        const formData = new FormData(form);
        const params = new URLSearchParams();
        formData.forEach((value, key) => {
          if (typeof value === 'string') {
            params.append(key, value);
          }
        });
        return params.toString();
      };
      static define = () => {
        if (!customElements.get('collection-filters')) {
          customElements.define('collection-filters', CollectionFilters);
        }
      };
    }
    var collectionFilters = () => {
      CollectionFilters.define();
    };

    var collectionFilters$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        CollectionFilters: CollectionFilters,
        default: collectionFilters
    });

    const {
      flip
    } = window.PoleneLibs.FlipAnimation;
    const {
      scrollToPosition
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef,
      getElementsByRef: getElementsByRef$1,
      getRefs
    } = window.PoleneLibs.Refs;
    const classes$1 = {
      active: 'is-active',
      visible: 'is-visible'
    };
    var collectionToggles = () => {
      const {
        collectionSection,
        backToTop
      } = getElementByRef(['collection-section', 'back-to-top']);
      const {
        collectionToggles
      } = getElementsByRef$1(['collection-toggles']);
      if (!collectionToggles || !collectionSection) return;
      let prevType;
      const toggleGroups = collectionToggles ? Array.isArray(collectionToggles) ? [...collectionToggles] : [collectionToggles] : [];
      let allToggles = toggleGroups.map(group => {
        const {
          toggles
        } = getRefs(group);
        return toggles;
      });
      allToggles = allToggles.flat();
      const init = () => {
        const layout = getLayoutFromParams();
        setEventListeners();
        setGridLayout(layout);
      };
      const setEventListeners = () => {
        const toggleBtns = allToggles ? [...allToggles] : [];
        if (backToTop) {
          window.addEventListener('scroll', handleScroll);
          const {
            backToTopBtn
          } = getRefs(backToTop);
          backToTopBtn.addEventListener('click', handleBackToTop);
        }
        toggleBtns.forEach(toggle => {
          toggle.addEventListener('click', handleLayoutClick);
        });
      };
      const isScrolled = () => window.scrollY > window.innerHeight;
      const handleScroll = () => {
        if (backToTop) {
          backToTop.classList.toggle(classes$1.visible, isScrolled());
          document.body.classList.toggle('scroll-to-top-visible', isScrolled());
        }
      };
      const handleBackToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      };
      const handleLayoutClick = e => {
        const {
          type
        } = e.currentTarget.dataset;
        if (type === prevType) return;
        prevType = type;
        flip('grid', () => {
          scrollToPosition(0, 1000);
          setGridLayout(type);
          updateUrl(type);
        });
      };
      const setGridLayout = selectedLayout => {
        const {
          defaultLayout
        } = collectionSection.dataset;
        const layout = selectedLayout ?? defaultLayout;
        prevType = layout;
        collectionSection.dataset.layout = layout;
        allToggles.forEach(toggle => {
          if (toggle.dataset.type == layout) {
            toggle.classList.add(classes$1.active);
          } else {
            toggle.classList.remove(classes$1.active);
          }
        });
      };
      const getLayoutFromParams = () => {
        let layout = null;
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.forEach((value, key) => {
          if (key === 'layout') {
            layout = value;
          }
        });
        return layout;
      };
      const updateUrl = layout => {
        const url = new URL(window.location.href);
        const documentTitle = document.getElementsByTagName('title')[0].innerHTML;
        url.searchParams.set('layout', layout);
        if (history && history.replaceState) {
          history.replaceState({}, documentTitle, url);
        }
      };
      init();
      return () => {
        if (backToTop) {
          window.removeEventListener('scroll', handleScroll);
          const {
            backToTopBtn
          } = getRefs(backToTop);
          backToTopBtn.removeEventListener('click', handleBackToTop);
        }
        allToggles.forEach(toggle => {
          toggle.removeEventListener('click', handleLayoutClick);
        });
      };
    };

    var collectionToggles$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: collectionToggles
    });

    const {
      getElementsByRef
    } = window.PoleneLibs.Refs;
    const classes = {
      overflowLeft: 'has-overflow-left',
      overflowRight: 'has-overflow-right'
    };
    var collectionMenu = () => {
      const {
        collectionMenu,
        collectionMenuList,
        collectionMenuInner,
        buttonLeft,
        buttonRight
      } = getElementsByRef(['collection-menu', 'collection-menu-list', 'collection-menu-inner', 'button-left', 'button-right']);
      if (!collectionMenu || !collectionMenuList || !collectionMenuInner || !buttonLeft || !buttonRight) return;
      const filters = Array.isArray(collectionMenu) ? [...collectionMenu] : [collectionMenu];
      if (!filters) return;
      const init = () => {
        setEventListeners();
        checkOverflow();
      };
      const setEventListeners = () => {
        window.addEventListener('resize', checkOverflow);
        if (!Array.isArray(collectionMenuList)) collectionMenuList.addEventListener('scroll', checkOverflow);else collectionMenuList.forEach(list => list.addEventListener('scroll', checkOverflow));
        if (!Array.isArray(buttonLeft)) buttonLeft.addEventListener('click', goLeft);else buttonLeft.forEach(button => button.addEventListener('click', goLeft));
        if (!Array.isArray(buttonRight)) buttonRight.addEventListener('click', goRight);else buttonRight.forEach(button => button.addEventListener('click', goRight));
      };
      filters.forEach(filter => {
        const activeLink = filter.querySelector('.active');
        if (!activeLink) return;
        activeLink.scrollIntoView({
          block: 'nearest',
          inline: 'center',
          behavior: 'smooth'
        });
      });
      const checkOverflow = () => {
        if (Array.isArray(collectionMenuList) || Array.isArray(collectionMenuInner)) return;
        const isOverflowingRight = collectionMenuList.scrollWidth - collectionMenuList.scrollLeft - 12.5 > collectionMenuInner.clientWidth;
        const isOverflowingLeft = collectionMenuList.scrollLeft > 0;
        collectionMenuInner.classList.toggle(classes.overflowLeft, isOverflowingLeft);
        collectionMenuInner.classList.toggle(classes.overflowRight, isOverflowingRight);
      };
      const goLeft = () => {
        if (Array.isArray(collectionMenuList)) return;
        collectionMenuList.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      };
      const goRight = () => {
        if (Array.isArray(collectionMenuList)) return;
        collectionMenuList.scrollTo({
          left: collectionMenuList.scrollWidth - collectionMenuList.clientWidth,
          behavior: 'smooth'
        });
      };
      init();
      return () => {
        window.removeEventListener('resize', checkOverflow);
        if (!Array.isArray(collectionMenuList)) collectionMenuList.removeEventListener('scroll', checkOverflow);else collectionMenuList.forEach(list => list.removeEventListener('scroll', checkOverflow));
        if (!Array.isArray(buttonLeft)) buttonLeft.removeEventListener('click', goLeft);else buttonLeft.forEach(button => button.removeEventListener('click', goLeft));
        if (!Array.isArray(buttonRight)) buttonRight.removeEventListener('click', goRight);else buttonRight.forEach(button => button.removeEventListener('click', goRight));
      };
    };

    var collectionMenu$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: collectionMenu
    });

})();
